import { __awaiter } from "tslib";
import { useMessage } from '@/const/messages';
import ApiManager from '@/managers/apimanagers';
import { useStore } from '@/store/store';
import { inject } from 'vue';
import MyPusher from './pusher';
import { useSound } from '@/logics/sound';
const MAX_CLOSED_ORDERS = 30;
export const useMyOrder = () => {
    const store = useStore();
    /**
     * @returns 自身の注文情報のリスト
     */
    const getOpenOrder = (pair) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/open-orders`;
        const params = { pair };
        store.state.openList = yield ApiManager.get(url, params).catch((err) => {
            return Promise.reject(err);
        });
    });
    /**
     * @returns 閉じた注文情報
     */
    const getClosedOrder = (pair, limit = MAX_CLOSED_ORDERS, offset = 1) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/closed-orders`;
        const params = { limit, offset, pair };
        store.state.closedList = yield ApiManager.get(url, params).catch((err) => {
            return Promise.reject(err);
        });
    });
    return { getOpenOrder, getClosedOrder };
};
/**
 * @summary 自身の注文情報の購読 OPEN ORDER
 */
export const myOpenOrderSubscriber = (userId) => {
    const toast = inject('toast');
    const store = useStore();
    const { format, CANCEL_MESSAGES } = useMessage();
    let channel;
    const subscribe = () => {
        if (userId !== undefined && userId !== null) {
            channel = MyPusher.subscribe(`private-${userId}-my-orders-table`);
            channel.bind(`my-orders-table-change-open`, bind);
        }
    };
    const unsubscribe = () => {
        channel === null || channel === void 0 ? void 0 : channel.unbind();
        channel === null || channel === void 0 ? void 0 : channel.unsubscribe();
    };
    const bind = (data) => {
        data.pair = data.pair.toUpperCase();
        const isExists = store.state.openList.find((l) => l.id === data.id);
        if (data.actions === 'canceled') {
            toast.success(format(CANCEL_MESSAGES.SUCCESS));
        }
        if (!isExists && Number(data.executed) === Number(data.amount)) {
            return;
        }
        if (isExists) {
            if (Number(data.executed) === Number(data.amount)) {
                store.state.openList = store.state.openList.filter((l) => l.id !== isExists.id);
                return;
            }
            // すでに存在するOrder情報の場合は書き換え
            store.state.openList = store.state.openList
                .map((l) => {
                return l.id === data.id ? data : l;
            })
                .filter((l) => l.amount !== l.executed);
        }
        else {
            // 無い場合は追加
            store.state.openList = [data, ...store.state.openList].filter((l) => ['executing', 'waiting'].includes(l.actions));
        }
    };
    return { subscribe, unsubscribe, bind };
};
/**
 * @summary 自身の注文情報の購読 CLOSED ORDER
 */
export const myClosedOrderSubscriber = (userId) => {
    const toast = inject('toast');
    const store = useStore();
    const { yakujo, play } = useSound();
    const { format, CLOSED_ORDERS_MESSAGES } = useMessage();
    const event = new CustomEvent('cryptos-contract');
    let channel;
    const subscribe = () => {
        if (userId !== undefined && userId !== null) {
            channel = MyPusher.subscribe(`private-${userId}-my-orders-table`);
            channel.bind(`my-orders-table-change-closed`, bind);
        }
    };
    const unsubscribe = () => {
        channel === null || channel === void 0 ? void 0 : channel.unbind();
        channel === null || channel === void 0 ? void 0 : channel.unsubscribe();
    };
    const stockClosedOrders = [];
    const stock = (newOrders) => {
        // 1秒に一回だけ画面描画させる（フロント負荷軽減のため）
        if (stockClosedOrders.length === 0) {
            setTimeout(() => {
                const simpleStockClosedOrders = [...stockClosedOrders].filter((obj) => !store.state.userSettings.isLimitedClosePair ||
                    obj.pair.toLowerCase() === store.getters.symbol.pair.toLowerCase());
                store.state.closedList = [...simpleStockClosedOrders, ...store.state.closedList].filter((_, index) => index < MAX_CLOSED_ORDERS);
                play(yakujo);
                toast.success(format(CLOSED_ORDERS_MESSAGES.SUCCESS));
                window.dispatchEvent(event);
                stockClosedOrders.length = 0;
            }, 1000);
        }
        stockClosedOrders.push(newOrders);
    };
    const bind = (data) => {
        data.pair = data.pair.toUpperCase();
        stock(data);
    };
    return { subscribe, unsubscribe, bind };
};
